<template>
  <div class="page t-container">
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">
        Tracking
      </h1>
    </div>

    <div class="t-flex t-justify-center t-my-8 t-border-b t-border-gray-400 md:t-justify-start">
      <nav class="t-flex t-space-x-4 md:t-space-x-6">
        <a
          @click.prevent="changeTab('AssetsTab')"
          :class="{ 't-border-b-2 t-border-dodger-blue': currentTab === 'AssetsTab'}"
          class="t-text-lg t-font-medium t-gray-600 t-py-2 md:t-py-0 t-text-center t-cursor-pointer"
        >
          <div class="t-py-2">
            My Assets
          </div>
        </a>
        <a
          @click.prevent="changeTab('OnSiteTrackersTab')"
          :class="{ 't-border-b-2 t-border-dodger-blue': currentTab === 'OnSiteTrackersTab'}"
          class="t-text-lg t-font-medium t-gray-600 t-py-2 md:t-py-0 t-text-center t-cursor-pointer t-pb-2"
        >
          <div class="t-py-2">
            On Site
          </div>
        </a>
        <a
          @click.prevent="changeTab('OffSiteTrackersTab')"
          :class="{ 't-border-b-2 t-border-dodger-blue': currentTab === 'OffSiteTrackersTab'}"
          class="t-text-lg t-font-medium t-gray-600 t-py-2 md:t-py-0 t-text-center t-cursor-pointer t-pb-2"
        >
          <div class="t-py-2">
            Off Site
          </div>
        </a>
      </nav>
    </div>

    <keep-alive>
      <on-site-trackers-tab
        v-if="currentTab === 'OnSiteTrackersTab'"
        :map-raw-trackers="mapRawTrackers"
      />
      <off-site-trackers-tab
        v-if="currentTab === 'OffSiteTrackersTab'"
        :map-raw-trackers="mapRawTrackers"
      />
      <assets-tab
        v-if="currentTab === 'AssetsTab'"
        :map-raw-trackers="mapRawTrackers"
      />
    </keep-alive>
  </div>
</template>

<script>
import moment from "moment";
import OnSiteTrackersTab from "./OnSiteTrackersTab";
import OffSiteTrackersTab from "./OffSiteTrackersTab";
import AssetsTab from "./AssetsTab";

export default {
  name: 'TrackingPage',
  description: 'The tracking page',
  components: {
    OnSiteTrackersTab,
    OffSiteTrackersTab,
    AssetsTab
  },
  data () {
    return {
      currentTab: 'AssetsTab'
    }
  },
  mounted() {
    this.selectedTab();
  },
  computed: {
    tabQuery() {
      return this.$route.query.tab;
    }
  },
  methods: {
    mapRawTrackers(rawTrackers) {
      return rawTrackers.map(tracker => {
        return {
          id: tracker.eroad_device_id,
          battery: tracker.battery,
          bookingId: tracker.last_booking_id,
          previousLocation: tracker.previous_location,
          currentLocation: tracker.current_location,
          updatedAt: (tracker.last_location && tracker.last_location.time) ? moment(tracker.last_location.time) : '',
          unlinkedAt: tracker.unlinked_at === '' ? '' : moment(tracker.unlinked_at),
          assetName: tracker.eroad_asset_id,
          recipient: tracker.recipient ? tracker.recipient : '',
          lat: tracker.lat,
          lng: tracker.lng
        }
      });
    },
    changeTab(newTab) {
      this.currentTab = newTab;
    },
    selectedTab() {
      this.currentTab = this.tabQuery == null ? 'AssetsTab' : this.tabQuery;
    }
  }
}
</script>

<style scoped>
p {
  margin: 0;
}

.stuff {
  min-width: 60rem;
}
</style>
